import React from 'react';
import Meta from '../components/Meta';
import ARVSection from '../components/ARVSection/ARVSection';
import { requireAuth } from '../util/auth';

const ARVPage = () => {
  return (
    <>
      <Meta title="1090 accuracy with ARV" />
      <ARVSection />
    </>
  );
};

export default requireAuth(ARVPage);
